import { ReceiveExecutionStatus } from '../../store/types';

export const EXECUTION_ERROR_STATES = [
  ReceiveExecutionStatus.FAILED_INVENTORY_UPDATE,
  ReceiveExecutionStatus.PARTIALLY_FAILED_INVENTORY_UPDATE,
  ReceiveExecutionStatus.FAILED_LINE_ITEM_RECONCILIATION,
  ReceiveExecutionStatus.FAILED_VALIDATION,
  ReceiveExecutionStatus.FAILED_RECEIVE_STORE,
  ReceiveExecutionStatus.CONTAINER_NOT_IN_USER_CUSTODY,
  ReceiveExecutionStatus.DUPLICATE_TOTE_EXISTS,
  ReceiveExecutionStatus.INVENTORY_ADJUSTMENT_SERIAL_FAILURE_DUPLICATE_INVENTORY_MODIFICATION
];

export const EXECUTION_SUCCESS_STATES = [
  ReceiveExecutionStatus.COMPLETED_INVENTORY_UPDATE,
  ReceiveExecutionStatus.COMPLETED_RECEIVE_STORE,
  ReceiveExecutionStatus.COMPLETED_FINANCIAL_RECEIPT_CREATION,
  ReceiveExecutionStatus.COMPLETED_RECEIVE_NOTIFICATION_GENERATION,
  ReceiveExecutionStatus.FAILED_RECEIVE_STORE,
  ReceiveExecutionStatus.FAILED_FINANCIAL_RECEIPT_CREATION,
  ReceiveExecutionStatus.FAILED_RECEIPT_NOTIFICATION_GENERATION,
  ReceiveExecutionStatus.SUCCESSFULLY_COMPLETED_RECEIVE,
];

export const SERIALS_RECEIVED_PROCESSED = 'SerialsReceivedAndProcessed';
export const SERIALS_RECEIVED_SUCCEEDED = 'SerialsReceivedAndProcessed';
export const SERIALS_RECEIVED_ERRORED = 'SerialsReceivedAndProcessed';


// All serial state to be in completed state for the workflow to be complete
export const EXECUTION_COMPLETED_STATES = [
  ReceiveExecutionStatus.COMPLETED_FINANCIAL_RECEIPT_CREATION,
  ReceiveExecutionStatus.COMPLETED_RECEIVE_STORE,
  ReceiveExecutionStatus.COMPLETED_RECEIVE_NOTIFICATION_GENERATION,
  ReceiveExecutionStatus.FAILED_VALIDATION,
  ReceiveExecutionStatus.FAILED_LINE_ITEM_RECONCILIATION,
  ReceiveExecutionStatus.FAILED_INVENTORY_UPDATE,
  ReceiveExecutionStatus.PARTIALLY_FAILED_INVENTORY_UPDATE,
  ReceiveExecutionStatus.FAILED_RECEIVE_STORE,
  ReceiveExecutionStatus.FAILED_FINANCIAL_RECEIPT_CREATION,
  ReceiveExecutionStatus.FAILED_RECEIPT_NOTIFICATION_GENERATION,
  ReceiveExecutionStatus.SUCCESSFULLY_COMPLETED_RECEIVE,
  ReceiveExecutionStatus.CONTAINER_NOT_IN_USER_CUSTODY,
  ReceiveExecutionStatus.DUPLICATE_TOTE_EXISTS,
  ReceiveExecutionStatus.INVENTORY_ADJUSTMENT_SERIAL_FAILURE_DUPLICATE_INVENTORY_MODIFICATION
];

export const EXECUTION_STATE_MESSAGES: { [key: string]: string } = {
  [ReceiveExecutionStatus.STARTED_WORKFLOW]: 'started workflow for receiving the part',

  [ReceiveExecutionStatus.COMPLETED_VALIDATION]: 'completed validation for the part',
  [ReceiveExecutionStatus.COMPLETED_INVENTORY_UPDATE]: 'inventory is updated',
  [ReceiveExecutionStatus.COMPLETED_LINE_ITEM_RECONCILIATION]: 'completed updating the receive counts',
  [ReceiveExecutionStatus.COMPLETED_FINANCIAL_RECEIPT_CREATION]: 'completed creating a financial receipt',
  [ReceiveExecutionStatus.COMPLETED_RECEIVE_NOTIFICATION_GENERATION]: 'received receive notification',

  [ReceiveExecutionStatus.FAILED_FINANCIAL_RECEIPT_CREATION]: 'error creating a receipt for the receive',
  [ReceiveExecutionStatus.FAILED_RECEIPT_NOTIFICATION_GENERATION]: 'error notifying receipt generation',

  [ReceiveExecutionStatus.FAILED_INVENTORY_UPDATE]: 'error updating part to inventory',
  [ReceiveExecutionStatus.FAILED_LINE_ITEM_RECONCILIATION]: 'error updating receive count',
  [ReceiveExecutionStatus.FAILED_VALIDATION]: 'error validating the part',
  [ReceiveExecutionStatus.CONTAINER_NOT_IN_USER_CUSTODY]: 'error receiving parts in a container that is not in custody',
  [ReceiveExecutionStatus.DUPLICATE_TOTE_EXISTS]: 'error duplicate tote exists',
  [ReceiveExecutionStatus.INVENTORY_ADJUSTMENT_SERIAL_FAILURE_DUPLICATE_INVENTORY_MODIFICATION]: 'error receiving part that has already been received'
};
